import React from 'react';
import { MapPinIcon, PhoneIcon, UserIcon, ShieldCheckIcon } from 'lucide-react';
import { WA_URL } from './constants';
export function Footer() {
  return <footer className="bg-navy-dark text-gray-400 py-12 border-t border-white/10" data-id="element-37">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-38">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8" data-id="element-39">
          <div className="lg:col-span-2" data-id="element-40">
            <div className="flex items-center gap-2 text-white font-bold text-xl mb-4" data-id="element-41">
              <ShieldCheckIcon className="w-6 h-6 text-orange" data-id="element-42" />
              <span data-id="element-43">Mauricio Ramírez Construcciones</span>
            </div>
            <p className="max-w-sm mb-6" data-id="element-44">
              Construcciones con garantía, seriedad y presupuesto gratis.
              Respaldamos cada proyecto con garantía de 5 años y contrato ante
              notaría.
            </p>
          </div>

          <div data-id="element-45">
            <h3 className="text-white font-semibold mb-4" data-id="element-46">Contacto</h3>
            <ul className="space-y-3" data-id="element-47">
              <li className="flex items-center gap-3" data-id="element-48">
                <UserIcon className="w-5 h-5 text-orange" data-id="element-49" />
                <span data-id="element-50">Mauricio Ramírez</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-51">
                <PhoneIcon className="w-5 h-5 text-orange" data-id="element-52" />
                <span data-id="element-53">+56 9 2095 2752</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-54">
                <MapPinIcon className="w-5 h-5 text-orange" data-id="element-55" />
                <span data-id="element-56">[Ciudad / Región], Chile</span>
              </li>
            </ul>
          </div>

          <div data-id="element-57">
            <h3 className="text-white font-semibold mb-4" data-id="element-58">Información</h3>
            <ul className="space-y-3" data-id="element-59">
              <li data-id="element-60">Atención previa coordinación</li>
              <li data-id="element-61">Presupuestos gratis</li>
              <li data-id="element-62">Garantía de 5 años</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-sm" data-id="element-63">
          <p data-id="element-64">
            &copy; {new Date().getFullYear()} Mauricio Ramírez Construcciones.
            Todos los derechos reservados.
          </p>
          <div className="flex gap-4" data-id="element-65">
            <a href={WA_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-66">
              Contactar por WhatsApp
            </a>
          </div>
        </div>
      </div>
    </footer>;
}